import { theme } from 'antd';

export type Tono = 'neutro' | 'corso' | 'attesa' | 'chiuso' | 'negato';

/** Chiavi normalizzate: minuscolo, spazi -> underscore. */
function normalizza(v?: string | null): string {
  return (v ?? '').trim().toLowerCase().replace(/\s+/g, '_');
}

const SCHEDA: Record<string, Tono> = {
  bozza: 'neutro',
  accettazione: 'neutro',
  in_analisi: 'corso',
  in_approvazione: 'attesa',
  approvata: 'corso',
  in_lavorazione: 'corso',
  completata: 'chiuso',
  riconsegnata: 'chiuso',
  sospesa: 'attesa',
  annullata: 'negato',
};

const INTERVENTO: Record<string, Tono> = {
  non_iniziato: 'neutro',
  iniziato: 'corso',
  sospeso: 'attesa',
  completato: 'chiuso',
};

export const tonoScheda = (s?: string | null): Tono =>
  SCHEDA[normalizza(s)] ?? 'neutro';

export const tonoIntervento = (s?: string | null): Tono =>
  INTERVENTO[normalizza(s)] ?? 'neutro';

export interface ColoriTono {
  testo: string;
  sfondo: string;
  bordo: string;
}

/** Hook: traduce un tono nei token semantici del tema corrente. */
export function useColoriTono(tono: Tono): ColoriTono {
  const { token } = theme.useToken();
  switch (tono) {
    case 'corso':
      return { testo: token.colorPrimary, sfondo: token.colorPrimaryBg, bordo: token.colorPrimaryBorder };
    case 'attesa':
      return { testo: token.colorWarning, sfondo: token.colorWarningBg, bordo: token.colorWarningBorder };
    case 'chiuso':
      return { testo: token.colorSuccess, sfondo: token.colorSuccessBg, bordo: token.colorSuccessBorder };
    case 'negato':
      return { testo: token.colorError, sfondo: token.colorErrorBg, bordo: token.colorErrorBorder };
    default:
      return { testo: token.colorTextTertiary, sfondo: token.colorFillTertiary, bordo: token.colorBorder };
  }
}
